// src/pages/cobranzas/ConsultaCobranzas2.jsx
import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import Layout from '../../../components/Layout';
import { AuthUser } from '../../../components/AuthUser';
import { Searchbar } from '../../../components/Searchbar';
import { DetalleCobranzas } from './DetalleCobranzas'; // si lo quieres renombrar, ajusta
import Pagination from 'react-responsive-pagination';
import { Dropdown, DropdownButton } from 'react-bootstrap';
import { DateRangePicker, Stack } from 'rsuite';
import startOfMonth from 'date-fns/startOfMonth';
import endOfMonth from 'date-fns/endOfMonth';
import addMonths from 'date-fns/addMonths';

import {
  getCobranzasxCliente2,
  getAllCobranzas2,
  SearchCobranzas2
} from '../../../api/requestCobranzas';
import { CobranzasPendientesXLS } from '../../XLS/CobranzasPendientesXLS';
import { DetalleCobranzas2 } from './DetalleCobranzas2';

export const ConsultaCobranzas2 = () => {
  const { user } = AuthUser();
  const navigate = useNavigate();
  const location = useLocation();

  const [loading, setLoading] = useState(true);
  const [searchbarDoc, setSearchbarDoc] = useState('d-none');
  const [searchbarCli, setSearchbarCli] = useState('d-none');
  const [searchbarVend, setSearchbarVend] = useState('d-none');
  const [searchDate, setSearchDate] = useState('d-none');

  const [term, setTerm] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [notFound, setNotFound] = useState(false);
  const [searching, setSearching] = useState(false);
  const [inicio, setInicio] = useState('');
  const [fin, setFin] = useState('');

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [urlPage, setUrlPage] = useState('');
  const [currentPage, setCurrentPage] = useState(1);

  const [Cobranzas, setCobranzas] = useState([]);

  const predefinedRanges = [
    { label: 'Últimos 3 meses', value: [startOfMonth(addMonths(new Date(), -3)), endOfMonth(addMonths(new Date(), -1))] },
    { label: 'Últimos 6 meses', value: [startOfMonth(addMonths(new Date(), -6)), endOfMonth(addMonths(new Date(), -1))] },
    { label: 'Último año', value: [new Date(new Date().getFullYear() - 1, 0, 1), new Date(new Date().getFullYear(), 0, 0)] }
  ];

  // helper para reemplazar page en url
  const replacePageInUrl = (url, pageNum) => {
    if (!url) return url;
    if (/[?&]page=\d+/.test(url)) return url.replace(/([?&]page=)\d+/, `$1${pageNum}`);
    return url.includes('?') ? `${url}&page=${pageNum}` : `${url}?page=${pageNum}`;
  };

  const fetchCobranzas = useCallback(async (url = null, options = {}) => {
    setLoading(true);
    try {
      let data = null;

      if (url) {
        // url completa ya formada (la backend2 devuelve meta/links/data)
        const resp = await fetch(url, { method: 'GET' }); // usando fetch directo para evitar RequestPage inconsistente
        const json = await resp.json();
        data = json?.data ? json : { data: json }; // si ya está en formato, mantenemos
      } else {
        // sin url: llamamos a la función que construye su propia url según user
        const pageParam = options.page || 1;
        if (user.CodVendedor !== null && user.CodSupervisor !== null && user.CodGerente === null) {
          data = await getCobranzasxCliente2(user.CodVendedor, pageParam);
        } else {
          data = await getAllCobranzas2(user.CodVendedor, pageParam);
        }
      }

      // normalizar (acepta { meta, links, data } o el paginator de Laravel)
      const body = data?.data ? data : (data ?? {});
      // si el backend devolvió paginator directamente (current_page,...), transformarlo:
      const normalized = body.data ? {
        current_page: body.meta?.current_page ?? body.current_page,
        last_page: body.meta?.last_page ?? body.last_page,
        first_page_url: body.links?.first ?? body.first_page_url,
        links: body.links ?? body.links,
        data: body.data
      } : { current_page: 1, last_page: 1, first_page_url: '', data: [] };

      setPage(Number(normalized.current_page ?? 1));
      setTotalPages(Number(normalized.last_page ?? 1));
      setUrlPage(normalized.first_page_url ?? '');
      setCurrentPage(Number(normalized.current_page ?? 1));
      setCobranzas(normalized.data ?? []);
      setNotFound(!(normalized.data && normalized.data.length));
    } catch (err) {
      console.error('fetchCobranzas error:', err);
      setCobranzas([]);
      setNotFound(true);
    } finally {
      setLoading(false);
    }
  }, [user]);

  // mount & handle ?page=
  useEffect(() => {
  (async () => {
    const params = new URLSearchParams(location.search);
    const p = parseInt(params.get('page') || '1', 10);

    // Reconstruir filtros desde la querystring
    const filters = {
      whatToSearch: params.get('whatToSearch') || null,
      Busqueda: params.get('Busqueda') || null,
      fechaInicio: params.get('fechaInicio') || null,
      fechaFin: params.get('fechaFin') || null
    };

    // sincronizar UI con querystring
    setSearchType(filters.whatToSearch ?? '');
    setSearchValue(filters.Busqueda ?? '');
    setFechaInicio(filters.fechaInicio ?? '');
    setFechaFin(filters.fechaFin ?? '');
    setCurrentFilters(filters);

    // Si hay filtros activos -> llamar al endpoint de búsqueda (SearchCobranzas2)
    if (filters.whatToSearch) {
      try {
        setLoading(true);
        const res = await SearchCobranzas2(
          user.CodVendedor,
          filters.whatToSearch,
          filters.Busqueda,
          filters.fechaInicio,
          filters.fechaFin,
          p
        );
        const body = res?.data ? res : (res ?? {});
        const normalized = body.data ? {
          current_page: body.meta?.current_page ?? body.current_page,
          last_page: body.meta?.last_page ?? body.last_page,
          first_page_url: body.links?.first ?? body.first_page_url,
          data: body.data
        } : { data: [] };

        setTerm(filters.Busqueda ?? '');
        setNotFound(!(normalized.data && normalized.data.length));
        setCurrentPage(Number(normalized.current_page ?? 1));
        setPage(Number(normalized.current_page ?? 1));
        setTotalPages(Number(normalized.last_page ?? 1));
        setCobranzas(normalized.data ?? []);
        setUrlPage(normalized.first_page_url ?? '');
      } catch (err) {
        console.error('useEffect SearchCobranzas2 error:', err);
        setCobranzas([]);
        setNotFound(true);
      } finally {
        setLoading(false);
      }
    } else {
      // No hay filtros: cargar listado normal según usuario (getAllCobranzas2/getCobranzasxCliente2)
      await fetchCobranzas(null, { page: p });
    }
  })();
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [location.search, fetchCobranzas, user.CodVendedor]);


  const handlePageChange = (pageNum) => {
  setCurrentPage(pageNum);
  const search = new URLSearchParams(location.search);

  // si no hay filtros actuales (currentFilters vacío) pero quieres preservar los filtros en la UI,
  // useEffect los reconstruirá desde location.search. Aquí sólo actualizamos page.
  search.set('page', String(pageNum));
  navigate({ pathname: location.pathname, search: `?${search.toString()}` }, { replace: true });

  // NO llamamos a fetchCobranzas aquí — useEffect con location.search hará la carga correcta.
};


  // search
  const onSearch = async () => {
  setLoading(true);
  setNotFound(false);

  // construir filtros
  const filters = {};
  if (searchType === 'Fecha' && fechaInicio && fechaFin) {
    filters.whatToSearch = 'Fecha';
    filters.fechaInicio = fechaInicio;
    filters.fechaFin = fechaFin;
  } else if (searchType) {
    filters.whatToSearch = searchType;
    filters.Busqueda = searchValue;
  }

  // guardar filtros en estado (opcional)
  setCurrentFilters(filters);

  // navega a page=1 con filtros en querystring; useEffect reaccionará y hará la petición correcta
  const qs = buildSearchParams(1, filters);
  navigate({ pathname: location.pathname, search: `?${qs}` }, { replace: true });

  // no ejecutar SearchCobranzas2 aquí — useEffect lo hará.
};


const clearFilters = () => {
  setSearchType('');
  setSearchValue('');
  setFechaInicio('');
  setFechaFin('');
  setCurrentFilters({});
  setNotFound(false);
  navigate({ pathname: location.pathname, search: `?page=1` }, { replace: true });
  // useEffect cargará la página 1 sin filtros
};



  const changeDate = async (e) => {
    setLoading(true);
    const date = JSON.stringify(e);
    const start = date.slice(2, 12) + ' ' + date.slice(14, 21);
    const end = date.slice(29, 39) + ' ' + date.slice(41, 48);
    try {
      const res = await SearchCobranzas2(user.CodVendedor, 'Fecha', null, start, end, 1);
      const body = res?.data ? res : (res ?? {});
      const normalized = body.data ? {
        current_page: body.meta?.current_page ?? body.current_page,
        last_page: body.meta?.last_page ?? body.last_page,
        first_page_url: body.links?.first ?? body.first_page_url,
        data: body.data
      } : { data: [] };

      setInicio(start);
      setFin(end);
      setNotFound(!(normalized.data && normalized.data.length));
      setCobranzas(normalized.data ?? []);
      setCurrentPage(Number(normalized.current_page ?? 1));
      setPage(Number(normalized.current_page ?? 1));
      setTotalPages(Number(normalized.last_page ?? 1));
      setUrlPage(normalized.first_page_url ?? '');
    } catch (err) {
      console.error('changeDate error:', err);
    } finally {
      setLoading(false);
    }
  };

  const showFilter = (e, filtro) => {
    e.preventDefault();
    setSearchTerm(filtro);
    const filters = {
      'Documento': { setSearchbarDoc: 'd-block', setSearchbarCli: 'd-none', setSearchbarVend: 'd-none', setSearchDate: 'd-none' },
      'Cliente': { setSearchbarDoc: 'd-none', setSearchbarCli: 'd-block', setSearchbarVend: 'd-none', setSearchDate: 'd-none' },
      'Vendedor': { setSearchbarDoc: 'd-none', setSearchbarCli: 'd-none', setSearchbarVend: 'd-block', setSearchDate: 'd-none' },
      'Fecha': { setSearchbarDoc: 'd-none', setSearchbarCli: 'd-none', setSearchbarVend: 'd-none', setSearchDate: 'd-block' },
      'Limpiar': { setSearchbarDoc: 'd-none', setSearchbarCli: 'd-none', setSearchbarVend: 'd-none', setSearchDate: 'd-none', setSearchTerm: '' },
      'default': { setSearchbarDoc: 'd-none', setSearchbarCli: 'd-none', setSearchbarVend: 'd-none', setSearchDate: 'd-none', setSearchTerm: '' }
    };
    const cfg = filters[filtro] || filters['default'];
    Object.entries(cfg).forEach(([k, v]) => {
      if (typeof eval(k) === 'function') eval(`${k}('${v}')`);
    });
  };

  // === FILTROS tipo Factura (añadir cerca de tus otros useState)
const [searchType, setSearchType] = useState(''); // Documento | Cliente | Vendedor | Fecha
const [searchValue, setSearchValue] = useState('');
const [fechaInicio, setFechaInicio] = useState('');
const [fechaFin, setFechaFin] = useState('');
const [currentFilters, setCurrentFilters] = useState({});

// Helper para construir querystring (usa en handlePageChange o navigate)
const buildSearchParams = (pageNum = 1, filters = {}) => {
  const params = new URLSearchParams();
  params.set('page', String(pageNum));
  if (filters.whatToSearch) params.set('whatToSearch', filters.whatToSearch);
  if (filters.Busqueda) params.set('Busqueda', filters.Busqueda);
  if (filters.fechaInicio) params.set('fechaInicio', filters.fechaInicio);
  if (filters.fechaFin) params.set('fechaFin', filters.fechaFin);
  return params.toString();
};


  return (
    <Layout>
      {loading ? (
        <div style={{ position: 'fixed', left: '50%', top: '50%', transform: 'translate(-50%, -50%)' }}>
          <span className="loader-cobranzas" />
        </div>
      ) : (
        <>
          <div className="consultas-title mt-5 pt-5">
            <h4 className="bg-belmeny text-light px-5 rounded-pill">Consulta de Cobranzas</h4>
          </div>

          <h5 className="text-center mt-2 mb-4 text-belmeny">
            <i>{user.CodGerente !== null ? `Supervisor / Gerente - ${user.Nombre} - ${user.CodVendedor}` : `Vendedor - ${user.Nombre} - ${user.CodVendedor}`}</i>
          </h5>

          {/* Desktop */}
          <div className="container-fluid d-md-block d-none mb-3">
            {/* FILTER UI (estilo ConsultaFactura) */}
            {/* ======== FILTROS (basado en ConsultaFactura, centrado y con mejor spacing) ======== */}
<div className="container mb-3">
  <div className="row align-items-center gy-2 justify-content-center">
    {/* Col auto para el select */}
    <div className="col-auto">
      <select
        className="form-select"
        value={searchType}
        onChange={(e) => {
          setSearchType(e.target.value);
          // reset value fields al cambiar tipo
          setSearchValue('');
          setFechaInicio('');
          setFechaFin('');
        }}
        style={{ minWidth: 180 }}
      >
        <option value="">-- Filtro --</option>
        <option value="Documento">Documento</option>
        <option value="Cliente">Cliente</option>
        <option value="Vendedor">Vendedor</option>
        <option value="Fecha">Fecha</option>
      </select>
    </div>

    {/* input texto (Documento, Cliente, Vendedor) */}
    {searchType && searchType !== 'Fecha' ? (
      <div className="col-auto d-flex" style={{ minWidth: 300 }}>
        <input
          type="text"
          className="form-control"
          placeholder={`Buscar por ${searchType}`}
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter') onSearch(); }}
          style={{ minWidth: 240 }}
        />
      </div>
    ) : null}

    {/* inputs de fecha (si seleccionó Fecha) */}
    {searchType === 'Fecha' ? (
      <>
        <div className="col-auto">
          <input
            type="date"
            className="form-control"
            value={fechaInicio}
            onChange={(e) => setFechaInicio(e.target.value)}
            style={{ minWidth: 150 }}
          />
        </div>
        <div className="col-auto">
          <input
            type="date"
            className="form-control"
            value={fechaFin}
            onChange={(e) => setFechaFin(e.target.value)}
            style={{ minWidth: 150 }}
          />
        </div>
      </>
    ) : null}

    {/* botones (separados del select con más espacio) */}
    <div className="col-auto d-flex align-items-center" style={{ gap: '0.6rem' }}>
      <button
        className="btn btn-primary"
        onClick={onSearch}
        style={{ marginLeft: searchType ? '10px' : 0, whiteSpace: 'nowrap' }}
      >
        Buscar
      </button>
      <button
        className="btn btn-outline-secondary"
        onClick={clearFilters}
        style={{ whiteSpace: 'nowrap' }}
      >
        Limpiar
      </button>
    </div>

    {/* botón XLS a la derecha en la misma fila (col-auto) */}
    <div className="col-auto" style={{ marginLeft: '8px' }}>
      <CobranzasPendientesXLS codvendedor={user.CodVendedor} />
    </div>

    {/* resumen o texto explicativo ocupa la fila siguiente en pantallas pequeñas,
        o se muestra alineado en una columna grande si hay espacio */}
    <div className="col-12 col-md-auto">
      <div className="mt-1">
        {searchType ? (
          <small className="text-muted">
            Filtro activo: <strong>{searchType}</strong>
            {searchType !== 'Fecha' && searchValue ? ` — ${searchValue}` : ''}
            {searchType === 'Fecha' && fechaInicio && fechaFin ? ` — ${fechaInicio} a ${fechaFin}` : ''}
          </small>
        ) : <small className="text-muted">Sin filtros</small>}
      </div>
    </div>
  </div>
</div>
{/* ======== FIN FILTROS ======== */}



            <div className="rounded-0 my-2">
              {notFound ? (
                <div className="alert alert-danger text-center"><h5>No se encontraron resultados</h5></div>
              ) : (
                <>
                  <table className="table table-bordered table-hover border-belmeny">
                    <thead className="bg-belmeny text-light text-center">
                      <tr>
                        <th>Cobranza</th>
                        <th className="w-50">Cliente</th>
                        {user.CodGerente !== null ? <th>Vendedor</th> : null}
                        <th>Monto</th>
                        <th>Fecha</th>
                        <th style={{ width: '15%' }}>Opciones</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Cobranzas.map(item => <DetalleCobranzas2 item={item} key={item.Documento} />)}
                    </tbody>
                  </table>

                  <Pagination total={totalPages} current={currentPage} onPageChange={handlePageChange} />
                </>
              )}
            </div>
          </div>

          {/* Mobile */}
          <div className="container-fluid d-block d-sm-block d-md-none">
            {/* (mobile markup similar to desktop omitted for brevity; reuse above logic) */}
            <div className="rounded-0 my-2">
              {Cobranzas.map(item => <DetalleCobranzas2 item={item} key={item.Documento + 'Mobile'} />)}
            </div>
            <Pagination total={totalPages} current={currentPage} onPageChange={handlePageChange} />
          </div>
        </>
      )}
    </Layout>
  );
};
